import { GetStaticPaths } from 'next';
import SectionNextPage, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default SectionNextPage;
